// Lazy loaders for the heavy PDF vendor libs so they are split into
// separate chunks and only fetched on pages that actually render PDFs.
let pdfjsPromise = null

export function loadPdfJs() {
  if (!pdfjsPromise) {
    pdfjsPromise = import("../../vendor/pdfjs/pdf.mjs").then((pdfjsLib) => {
      pdfjsLib.GlobalWorkerOptions.workerSrc = "/assets/js/pdf.worker.mjs"
      return pdfjsLib
    })
  }
  return pdfjsPromise
}

export function loadPdfLib() {
  return import("../../vendor/pdf-lib.mjs")
}
